import moment from 'moment-timezone';
import { Session, SessionFormat, SessionStatus } from '@app/api';
import { useMemo } from 'react';

export const getAllowedFormats = (session: Session): SessionFormat[] => {
  if (!session.format) {
    return [];
  }
  return [session.format];
};

export const useSesionMinAndMaxDatesString = (
  session?: Session,
  format: string = 'l',
): string => {
  return useMemo(() => {
    if (!session) {
      return '';
    }
    if (session.startDate && session.endDate) {
      return `${moment(session.startDate).format(format)} - ${moment(
        session.endDate,
      ).format(format)}`;
    }

    return '-';
  }, [session, format]);
};

export const isSessionOpen = (session?: Session) => {
  const sessionComplete =
    session !== undefined &&
    session.status !== SessionStatus.LIVE &&
    session.status !== SessionStatus.PAUSED &&
    session.status !== SessionStatus.DRAFT; // for preview

  return !sessionComplete;
};
